/**
 * 指定時間処理を待機する。
 * @param ms ミリ秒
 * @returns なし
 */
export const sleep = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
